import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { H3, RspImageBg } from '../base';
import media from '../base/media';
import { fadeIn } from '../base/keyframes/fades';

export const Link = styled(RouterLink)`
	display: block;
	height: 100%;
	padding: 1rem;
	background-color: #fff;
	box-shadow: 0 7px 17px 0 rgba(147,94,196,0.1);
	opacity: 0;
	animation: ${fadeIn} 300ms ease;
	animation-fill-mode: forwards;
	transition: transform 250ms ease, box-shadow 250ms ease;

	&:hover {
		transform: translate3d(0, -1px, 0);
		box-shadow: 0 10px 20px 0 rgba(147,94,196,0.1);
	}
`;

export const ContentWrapper = styled.div`
	padding: 2rem;

	${media.desktopSmall`
		padding-left: 4rem;
	`};

	> div, h3 {
		overflow: hidden;
	}
`;

export const Date = styled.div`
	color: ${({ theme }) => theme.colors.gray};
	font-size: 1.5rem;
	margin-bottom: 1rem;
`;

export const Title = styled(H3)`
	color: ${({ theme }) => theme.colors.black};
	line-height: 2.8rem;
	max-width: 28rem;
	margin-bottom: 1.5rem;
`;

export const Summary = styled.div`
	color: ${({ theme }) => theme.colors.gray};
`;

export const Image = styled(RspImageBg)`
	display: none;
	height: 100%;
	background-size: cover;
	background-position: 50% 50%;

	${media.desktopSmall`
		display: block;
	`}
`;
